import Card from "../../../models/common/Card";
import iconOne from '../../../assets/img/partnerPortal/vippProgram/graphic.png';
import iconTwo from '../../../assets/img/partnerPortal/vippProgram/reward.png';
import iconThird from '../../../assets/img/partnerPortal/vippProgram/more_rewards.png';
import iconFour from '../../../assets/img/partnerPortal/vippProgram/activating.png';
import iconFive from '../../../assets/img/partnerPortal/vippProgram/rebate.png';
import iconSive from '../../../assets/img/partnerPortal/vippProgram/fiscal_year.png';


// BANNER
export const TITLE = <div>The Dynatrace Value<br></br> Incentive Partner<br></br> Program (VIPP)</div>;
export const SUB_TITLE = <div>Partnerships are built on mutual success. It’s why we’re so excited<br></br> to introduce a new, more rewarding Value Incentive Partner<br></br> Program (VIPP). </div>;
export const BUTTON_NAME = "Get started";
export const BUTTON_LINK = "https://university.dynatrace.com/ondemand/course/35226?content=content&section=35374";
// --


// How does the program work ?
export const TITLE_CARDS = <div>Modernize the cloud, <br></br> maximize your growth</div>;
export const SUB_TITLE_CARDS = "Here's what's in it for you:";
const card1: Card = new Card("More opportunities to grow and maintain profitable business", "", iconOne);
const card2: Card = new Card("Rewards for achieving new business targets", "", iconTwo);
const card3: Card = new Card("More rewards for more deals", "", iconThird);

const cardsFirstRow: Card[] = [card1, card2, card3];

export const ALL_CARD_ROWS: Record<number, Card[]> = {
  [0]: cardsFirstRow,
}

// What are the requirements?
export const TITLE_2_CARDS = <div>What are the requirements</div>;
export const SUB_TITLE_2_CARDS = "We only have three small requirements for you to start earning with the first incentive VIPP (001):";
const card4: Card = new Card("Activating the VIPP (001)", "", iconFour, <div>Achieve <b>four or more</b> partner originated new logo resell or referral deals greater than <b>$10k net Annual Contract Value (ACV)</b> to Dynatrace</div>);
const card5: Card = new Card("Rebate eligibility", "New logo deals — incentive is paid on any of the qualifying deals above $100K net ACV to Dynatrace, once the VIPP (001) is activated (with 4+ new logos)", iconFive);
const card6: Card = new Card("Current fiscal year only", "Deals must be won during the current fiscal year (April 1, 2023 – March 31, 2024)", iconSive);

const cardsFirstRow_2: Card[] = [card4, card5, card6];

export const ALL_CARD_ROWS_2: Record<number, Card[]> = {
  [0]: cardsFirstRow_2,
} 
// --
// Looking for more information?
export const TITLE_3_CARDS = <div>Looking for more information?</div>;
export const SUB_TITLE_3_CARDS = "Check our our FAQ and Program Guide.";
export const BUTTON_ONE_NAME = "Program Guide";
export const BUTTON_ONE_LINK = "https://partners.dynatrace.com/#/collateral/8a9993b989457fda01894fe90c724632";
export const BUTTON_SECOND_NAME = "FAQ";
export const BUTTON_SECOND_LINK = "https://partners.dynatrace.com/#/collateral/8a9993b989457fda01894fead3bc46a4";

// --

// SIGN UP
export const SIGN_UP_TITLE = "Ready to get started?";
export const SIGN_UP_SUB_TITLE = "Simply enroll here and register your deals in the normal way.";
export const BANNER_LINK = "https://partners.dynatrace.com/#/co/8a9993b8893c4dfa01893f6b141750a6/instance/new/00000000000000000000000000000000";
export const BUTTON_NAME_SIGN_UP = "Enroll now";
// --

// NOTES
export const TITLE_NOTES = "The small print"
export const BODY_NOTES = <div><b>Program Eligibility</b>
                            <br></br>
                            <div className="ml-2">
                                ·&nbsp;&nbsp; VIPP is only available to Dynatrace partners who comply with the partner program and hold a current VAR partnership contract
                                <br></br>
                                ·&nbsp;&nbsp; Partners must formally enroll in the program and commit to a campaign/activity to generate demand to be eligible
                                <br></br>
                                ·&nbsp;&nbsp; VIPP (001) is only activated when a minimum of 4 new logos are closed greater than $10K net ACV to Dynatrace within FY24 
                                <br></br>
                                &nbsp;&nbsp;&nbsp;(April 1, 2023 – March 31, 2024)
                                <br></br>
                                ·&nbsp;&nbsp; Opportunities that qualify for a rebate pay-out must be new logo (defined as a new logo deal that originates from a legal entity 
                                <br></br>
                                &nbsp;&nbsp;&nbsp;where Dynatrace has not received any revenue from at least 6 months prior to the deal being booked), partner originated, resell 
                                <br></br>
                                &nbsp;&nbsp;&nbsp;or referral deals over $100k net ACV Dynatrace product bookings closed won within FY24
                                <br></br>
                                ·&nbsp;&nbsp; MSPs, Regional Franchise Operators (RFOs), Master Partners, and the Emerging Markets are excluded from VIPP (001)
                            </div>
                        </div>;


